var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"time-info"},[_c('h1',{staticClass:"time-info__date"},[_vm._v(_vm._s(_vm.currDate))]),_c('p',{staticClass:"time-info__time text-center"},[_c('font-awesome-icon',{staticClass:"mr-3",attrs:{"icon":['far', 'clock'],"size":"xl"}}),_vm._v(_vm._s(_vm.currTime)+" ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }